// extracted by mini-css-extract-plugin
export var arrowButton = "arrow-button-module--arrow-button--bfb27";
export var dark = "arrow-button-module--dark--fee18";